import { login, logout, getInfo, register } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { emitEvent } from '@/utils/eventBus'
import { supportedLanguages, defaultLanguage } from '@/lang/index'
import { toggleFavorite } from '@/api/favorite'
import { MessageBox } from 'element-ui'

// 语言管理工具函数
const createLanguageObject = (countryCode, name = null) => {
  const languageNames = {
    'en': 'English',
    'cn': '中文', 
    'es': 'Español',
    'fr': 'Français',
    'by': 'Русский',
    'de': 'Deutsch',
    'it': 'italiano'
  }
  return {
    country: countryCode,
    name: name || languageNames[countryCode] || 'English'
  }
}

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem('language')
    if (stored) {
      const parsed = JSON.parse(stored)
      if (supportedLanguages.includes(parsed.country)) {
        return parsed
      }
    }
  } catch (error) {
    console.warn('Failed to parse stored language:', error)
  }
  return createLanguageObject(defaultLanguage)
}

const setStoredLanguage = (languageObj) => {
  try {
    localStorage.setItem('language', JSON.stringify(languageObj))
  } catch (error) {
    console.error('Failed to store language:', error)
  }
}
const user = {
  namespaced: true,
  state: {
    token: getToken(),
    id: '',
    name: '',
    nickname: '',
    avatar: '',
    phone: '',
    email: '',
    country: '',
    company: '',
    roles: [],
    permissions: [],
    // 优化后的语言状态管理
    language: getStoredLanguage(), // 完整的语言对象
    lang: getStoredLanguage().country, // 快捷访问语言代码
    isLanguageLoaded: false // 语言加载状态
  },

  mutations: {
    // 优化的语言设置
    SET_LANGUAGE: (state, languageObj) => {
      // 验证语言对象格式
      if (!languageObj || !languageObj.country) {
        console.error('Invalid language object provided')
        return
      }
      
      // 验证语言是否支持
      if (!supportedLanguages.includes(languageObj.country)) {
        console.warn(`Unsupported language: ${languageObj.country}`)
        return
      }
      
      console.log(`Setting language from ${state.language.country} to ${languageObj.country}`)
      
      // 更新状态
      state.language = { ...languageObj }
      state.lang = languageObj.country
      
      // 持久化存储
      setStoredLanguage(languageObj)
      
      console.log('Language state after update:', state.language)
      
      // 触发语言切换事件
      emitEvent('language-changed', languageObj)
    },
    
    SET_LANGUAGE_LOADED: (state, loaded) => {
      state.isLanguageLoaded = loaded
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_COUNTRY: (state, country) => {
      state.country = country
    },
    SET_COMPANY: (state, company) => {
      state.company = company
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },
  actions: {
    // 优化的语言切换
    toggleLanguage({ commit, state }, languageInput) {
      return new Promise((resolve, reject) => {
        try {
          let languageObj
          
          // 处理不同类型的输入
          if (typeof languageInput === 'string') {
            languageObj = createLanguageObject(languageInput)
          } else if (languageInput && typeof languageInput === 'object') {
            languageObj = {
              country: languageInput.country,
              name: languageInput.name || createLanguageObject(languageInput.country).name
            }
          } else {
            reject(new Error('Invalid language input'))
            return
          }
          
          // 验证语言是否支持
          if (!supportedLanguages.includes(languageObj.country)) {
            reject(new Error(`Unsupported language: ${languageObj.country}`))
            return
          }
          
          // 提交状态变更
          commit('SET_LANGUAGE', languageObj)
          
          // 确保状态已更新
          console.log('Language state updated to:', state.language)
          
          resolve(languageObj)
        } catch (error) {
          console.error('Language toggle failed:', error)
          reject(error)
        }
      })
    },
    
    // 初始化语言设置
    initLanguage({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.isLanguageLoaded) {
          const storedLang = getStoredLanguage()
          commit('SET_LANGUAGE', storedLang)
          commit('SET_LANGUAGE_LOADED', true)
        }
        resolve(state.language)
      })
    },
    
    // 重置语言为默认值
    resetLanguage({ commit }) {
      return new Promise((resolve) => {
        const defaultLang = createLanguageObject(defaultLanguage)
        commit('SET_LANGUAGE', defaultLang)
        resolve(defaultLang)
      })
    },
    Register({commit},userInfo){
      const nickname = userInfo.firstname+'·'+userInfo.lastname;
      const username = userInfo.email.toString();
      const password = userInfo.password;
      const passwordtwo = userInfo.passwordtwo;
      const remark = '国家:'+userInfo.country+' /城市:'+userInfo.city+' /街道:'+userInfo.street+'/公司名称:'+userInfo.company;
      const email = userInfo.email
      const phonenumber =userInfo.zonePhone?userInfo.zonePhone: userInfo.phone
      const code = userInfo.code
      const uuid = userInfo.uuid
      const ip = userInfo.ip
      const country=userInfo.country;
      const company=userInfo.company;
      return new Promise((resolve, reject) => {
        register({username,nickname, password,passwordtwo,email,phonenumber, code, uuid,remark,ip,country,company}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit, dispatch }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(async res => {
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          try {
            await dispatch('GetInfo'); // 关键修改：登录后自动获取用户信息
            // 登录成功后同步本地收藏
            dispatch('syncLocalFavorites');
            resolve(res); // 用户信息获取成功后 resolve
          } catch (error) {
            // 可选：处理 GetInfo 失败的情况（如记录日志）
            resolve(res); // 即使失败也继续 resolve 登录流程
          }

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res
          const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/default.png") :user.avatar;
          commit('SET_ID', user.id)
          commit('SET_NAME', user.user)
          commit('SET_AVATAR', avatar)
          commit('SET_PHONE', user.phonenumber)
          commit('SET_EMAIL', user.email)
          commit('SET_COUNTRY', user.country)
          commit('SET_COMPANY', user.company)
          commit('SET_NICKNAME', user.nickName)
          if (user.permissions) {
            commit('SET_PERMISSIONS', user.permissions)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })

      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_ID', '')
          commit('SET_NAME', '')
          commit('SET_PHONE', '')
          commit('SET_EMAIL', '')
          commit('SET_COUNTRY', '')
          commit('SET_COMPANY', '')
          commit('SET_NICKNAME', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        emitEvent('logout-message',{})
        resolve()
      })
    },
    // 优化的清理信息函数
    CLEARNINFO({ commit }) {
      return new Promise(resolve => {
        // 清理用户信息
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_ID', '')
        commit('SET_NAME', '')
        commit('SET_PHONE', '')
        commit('SET_EMAIL', '')
        commit('SET_COUNTRY', '')
        commit('SET_COMPANY', '')
        commit('SET_NICKNAME', '')

        // 保留语言设置，不清理语言状态

        emitEvent('logout-message', {})
        removeToken()
        resolve()
      })
    },
    // 同步本地收藏到账号
    syncLocalFavorites({ state }) {
      try {
        const localFav = JSON.parse(localStorage.getItem('localFav') || '[]')
        if (localFav.length === 0) return

        MessageBox.confirm(
          'Local favorites detected. Sync to your account?',
          'Sync Local Favorites',
          { confirmButtonText: 'Sync', cancelButtonText: 'Cancel', type: 'info' }
        ).then(async () => {
          for (const pid of localFav) {
            try {
              await toggleFavorite(pid)
            } catch (e) {
              // Skip individual failures
            }
          }
          localStorage.removeItem('localFav')
        }).catch(() => {
          // User declined — keep localFav for next time
        })
      } catch (e) {
        // Ignore parse errors
      }
    }
  },
  getters: {
    avatar: state => state.avatar,
    // 新增语言相关 getters
    currentLanguage: state => state.language,
    currentLanguageCode: state => state.lang,
    isLanguageSupported: state => (langCode) => supportedLanguages.includes(langCode),
    availableLanguages: () => supportedLanguages.map(code => createLanguageObject(code))
  }
}

export default user
